import React from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import Button from '@material-ui/core/Button/Button';
import { CONVERT_HTML_PDF } from 'settings';
import Translate from 'components/Translate';
import CircularProgress from '@material-ui/core/CircularProgress';
import { SvgIcon } from 'components/SvgIcon';
import { pixelService, enPixelPath } from 'services/PixelService';

interface IState extends IStateBase {
  downloading: boolean;
}
interface IProps {
  bankslipUrl: string;
  nameButton: string;
}

export default class BoletoDownload extends BaseComponent<IState, IProps> {

  constructor(props: any) {
    super(props);

    this.state = { downloading: false };
  }

  handleClick = () => {
    pixelService.track(enPixelPath.BANKSLIP);
    this.setState({ downloading: true });
    setTimeout(() => this.setState({ downloading: false }), 10000);

    if (this.props.bankslipUrl.match(/pay\.dlocal\.com/)) {
      top.location.href = this.props.bankslipUrl;
      return;
    }

    top.location.href = `${CONVERT_HTML_PDF}${this.props.bankslipUrl}`;
  }

  render() {
    const { nameButton } = this.props;
    return (
      <div className={'chk-btn-download boleto theme-label'}>
        {!this.state.downloading ?
          <Button onClick={this.handleClick}>
            <div className='svgDownload'><SvgIcon name='download' /></div> <Translate term={nameButton} />
          </Button> :
          <Button disabled>
            <CircularProgress size={22} style={{ color: '#fff' }} />
          </Button>
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ThankYouPage/BoletoPage/BoletoDownload/index.tsx